if (!customElements.get('product-quick-buy')) {
  customElements.define(
    'product-quick-buy',
    class ProductQuickBuy extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantIdInput = this.form.querySelector('[name=id]');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const config = {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: new FormData(this.form),
        };

        fetch(`${window.theme.routes.cart_add_url}.js`, config)
          .then((response) => {
            if (!response.ok) {
              return response.json().then((json) => {
                throw new Error(json.description || 'An error occurred');
              });
            }
            return response.json();
          })
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              return;
            }

            document.body.dispatchEvent(
              new CustomEvent('baseline:modalcart:afteradditem', {
                bubbles: true,
                detail: { response: response },
              })
            );

            // Trigger the opening of the cart drawer using Spruce.store
            Spruce.store('drawer').cartOpener = this.submitButton;
            Spruce.store('drawer').cartDrawerOpen = true;

            window.dispatchEvent(new CustomEvent('close-product-modal'));

            if (window.theme.cartMethod == 'page') {
              getState().then((state) => {
                document.body.dispatchEvent(
                  new CustomEvent('baseline:modalcart:itemcountupdate', {
                    detail: {
                      count: state.item_count,
                    },
                  })
                );
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage(e.message);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        const errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper');

        if (errorMessage && errorMessageWrapper) {
          errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
          errorMessageWrapper.textContent = errorMessage;
        }
      }
    }
  );
}
